import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgChevronLeftIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="m23.601 27.07 15.4-12.32L41 17.249l-15.4 12.32v4.861L41 46.75 39 49.25l-15.4-12.32a3.2 3.2 0 0 1-1.2-2.499v-4.862a3.2 3.2 0 0 1 1.2-2.498"
    />
  </svg>
)
export default SvgChevronLeftIcon
